import { reactive, onMounted, ref, watch } from 'vue';
import mukiConst from '@/js/const.js';
import __unimport_mukiConst from '@/js/const.js';import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/menu/megaphone.svg';
import _imports_1 from '@/assets/images/menu/add.svg';
import _imports_2 from '@/assets/images/menu/delivery.svg';
import _imports_3 from '@/assets/images/menu/shopping-bag.svg';
import _imports_4 from '@/assets/images/menu/gift.svg';
import _imports_5 from '@/assets/images/menu/brochure.svg';
import _imports_6 from '@/assets/images/menu/user.svg';
import _imports_7 from '@/assets/images/menu/checklist.svg';
import _imports_8 from '@/assets/images/menu/contract.svg';
import _imports_9 from '@/assets/images/menu/mail.svg';
import _imports_10 from '@/assets/images/menu/video-game.svg';
import _imports_11 from '@/assets/images/menu/store.svg';
import _imports_12 from '@/assets/images/general/shop.svg';
import _imports_13 from '@/assets/images/general/car.svg';
import _imports_14 from '@/assets/images/icon/delete.png';
var _hoisted_1 = {
  class: "page-inner"
};

var _hoisted_2 = /*#__PURE__*/_createVNode("i", {
  class: "icon-delete"
}, null, -1);

var _hoisted_3 = {
  class: "panel-menu"
};

var _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_0,
  alt: ""
})], -1);

var _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 活動訊息 ", -1);

var _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_1,
  alt: ""
})], -1);

var _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 線上預購 ", -1);

var _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_2,
  alt: ""
})], -1);

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 行動超市 ", -1);

var _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_3,
  alt: ""
})], -1);

var _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 生活提案 ", -1);

var _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_4,
  alt: ""
})], -1);

var _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 優惠資訊 ", -1);

var _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_5,
  alt: ""
})], -1);

var _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 型錄DM ", -1);

var _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  style: {
    "max-width": "24px"
  },
  src: _imports_6,
  alt: ""
})], -1);

var _hoisted_17 = {
  class: "panel-menu-link-text"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode(" 會員中心");

var _hoisted_19 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_7,
  alt: ""
})], -1);

var _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 訂單查詢 ", -1);

var _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_8,
  alt: ""
})], -1);

var _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 消費紀錄 ", -1);

var _hoisted_23 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_9,
  alt: ""
})], -1);

var _hoisted_24 = {
  class: "panel-menu-link-text"
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode(" 收件夾 ");

var _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_10,
  alt: ""
})], -1);

var _hoisted_27 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 遊樂場 ", -1);

var _hoisted_28 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-icon-wrap"
}, [/*#__PURE__*/_createVNode("img", {
  class: "panel-menu-link-icon",
  src: _imports_11,
  alt: ""
})], -1);

var _hoisted_29 = /*#__PURE__*/_createVNode("div", {
  class: "panel-menu-link-text"
}, " 門市據點 ", -1);

var _hoisted_30 = {
  class: "col-item"
};

var _hoisted_31 = /*#__PURE__*/_createVNode("i", {
  class: "icon-home"
}, null, -1);

var _hoisted_32 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 首頁 ", -1);

var _hoisted_33 = {
  class: "col-item"
};

var _hoisted_34 = /*#__PURE__*/_createVNode("i", {
  class: "icon-brochure"
}, null, -1);

var _hoisted_35 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " DM ", -1);

var _hoisted_36 = {
  class: "col-ite"
};

var _hoisted_37 = /*#__PURE__*/_createVNode("i", {
  class: "icon-store"
}, null, -1);

var _hoisted_38 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 門市 ", -1);

var _hoisted_39 = {
  class: "col-item"
};

var _hoisted_40 = /*#__PURE__*/_createVNode("i", {
  class: "icon-user"
}, null, -1);

var _hoisted_41 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 會員 ", -1);

var _hoisted_42 = {
  class: "col-item"
};

var _hoisted_43 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, null, -1);

var _hoisted_44 = {
  class: "popup popup-tablet-fullscreen popup-crop_picture"
};
var _hoisted_45 = {
  class: "view"
};
var _hoisted_46 = {
  class: "page"
};
var _hoisted_47 = {
  class: "navbar text-color-white border-color-gray"
};

var _hoisted_48 = /*#__PURE__*/_createVNode("div", {
  class: "navbar-bg"
}, null, -1);

var _hoisted_49 = {
  class: "navbar-inner"
};
var _hoisted_50 = {
  class: "left"
};

var _hoisted_51 = /*#__PURE__*/_createVNode("i", {
  class: "icon-angle-left"
}, null, -1);

var _hoisted_52 = {
  class: "page-content"
};
var _hoisted_53 = {
  class: "page-content-inner"
};
var _hoisted_54 = {
  class: "page-inner"
};
var _hoisted_55 = {
  class: "crop_picture_block"
};

var _hoisted_56 = /*#__PURE__*/_createVNode("input", {
  type: "file",
  id: "crop_picture_file",
  accept: "image/jpg,image/jpeg,image/png",
  style: {
    "display": "none"
  }
}, null, -1);

var _hoisted_57 = {
  class: "crop_picture_wrap",
  id: "crop_picture_select_trigger"
};

var _hoisted_58 = /*#__PURE__*/_createVNode("div", {
  class: "form-group",
  id: "crop_picture_select_group"
}, [/*#__PURE__*/_createVNode("div", {
  class: "common_preview",
  id: "crop_picture_preview"
})], -1);

var _hoisted_59 = {
  type: "button",
  id: "crop_picture_select_btn",
  class: "bg-theme"
};

var _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"explain-wrap\"><h3 class=\"crop_picture_title text-theme\">建議尺寸：<span id=\"crop_picture_pic_size\"></span></h3><small class=\"crop_picture_tip \">可視範圍即為預覽效果<br>移動位置以拖曳方式操作</small></div><div class=\"crop_picture-btn-wrap\"><div class=\"row\"><div class=\"col-50\"><button type=\"button\" id=\"crop_picture_upload_btn\" class=\"col button btn-gt-theme size-h-45px\">上傳圖片</button></div><div class=\"col-50\"><button data-deg=\"90\" type=\"button\" id=\"crop_picture_rotate_btn\" class=\"col button btn-gt-theme size-h-45px\"><i class=\"btn-before fa fa-repeat btn-icon\" aria-hidden=\"true\"></i> 旋轉圖片 </button></div></div></div><div class=\"v-spacer-30px\"></div>", 3);

var _hoisted_63 = {
  class: "popup popup-tablet-fullscreen popup-sty-modal",
  id: "popup-sty-modal-default"
};
var _hoisted_64 = {
  class: "view"
};
var _hoisted_65 = {
  class: "page"
};
var _hoisted_66 = {
  class: "navbar"
};
var _hoisted_67 = {
  class: "navbar-inner"
};

var _hoisted_68 = /*#__PURE__*/_createVNode("div", {
  class: "left"
}, null, -1);

var _hoisted_69 = /*#__PURE__*/_createVNode("div", {
  class: "title"
}, null, -1);

var _hoisted_70 = {
  class: "right"
};
var _hoisted_71 = {
  class: "link popup-close popup-close-auto"
};

var _hoisted_72 = /*#__PURE__*/_createVNode("div", {
  class: "page-content popup-modal-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "popup-modal-content no-bg"
})])], -1);

var _hoisted_73 = {
  class: "popup popup-tablet-fullscreen popup-sty-modal popup-cart",
  id: "popup-cart"
};
var _hoisted_74 = {
  class: "view"
};
var _hoisted_75 = {
  class: "page"
};

var _hoisted_76 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar\"><div class=\"navbar-inner\"><div class=\"left\"></div><div class=\"title\"></div><div class=\"right\"></div></div></div>", 1);

var _hoisted_77 = {
  class: "page-inner"
};
var _hoisted_78 = {
  class: "popup-modal-content no-bg"
};
var _hoisted_79 = {
  class: "cart-info-card"
};

var _hoisted_80 = /*#__PURE__*/_createVNode("div", {
  class: "card-main"
}, [/*#__PURE__*/_createVNode("div", {
  class: "card-title"
}, " 線上預購 "), /*#__PURE__*/_createVNode("img", {
  class: "card-img",
  src: _imports_12,
  alt: "",
  srcset: ""
})], -1);

var _hoisted_81 = {
  class: "card-foot"
};
var _hoisted_82 = {
  class: "cart-info-card sty-2"
};

var _hoisted_83 = /*#__PURE__*/_createVNode("div", {
  class: "card-main"
}, [/*#__PURE__*/_createVNode("div", {
  class: "card-title"
}, " 行動超市 "), /*#__PURE__*/_createVNode("img", {
  class: "card-img",
  src: _imports_13,
  alt: "",
  srcset: ""
})], -1);

var _hoisted_84 = {
  class: "card-foot"
};

var _hoisted_85 = /*#__PURE__*/_createVNode("a", {
  class: "link popup-close popup-close-auto popup-tail-close no-margin-top"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_14,
  alt: "",
  srcset: ""
})], -1);

import { f7ready } from 'framework7-vue/bundle';
import routes from "@/js/routes.js";
import { useI18n } from "vue-i18n";
import { goMobileStore } from '@/js/functions.js';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { YoungSun, Logout } from "@/js/services/baseService"; // 除錯用

export default {
  expose: [],
  setup: function setup(__props) {
    var store = useStore();

    if (process.env.NODE_ENV === 'development') {
      window.store = store;
    }

    var appData = reactive({
      appShowCasePopup: {}
    });

    function onAppShowCasePopupInit(instance) {
      appData.appShowCasePopup = instance;
    } // 初始化


    onMounted(function () {
      // 推播相關功能必要
      _get_mobile_info();

      f7ready(function () {
        // console.log('app init')
        var href = location.href;
        var parseUrl = f7.utils.parseUrlQuery(href); // Panel事件

        f7.on('panelOpen', function (panel) {
          // 未讀優惠券
          store.dispatch('auth/updateMemberCouponUnread');
        });
        /**
         * 全域路徑
         */

        $$(document).on('page:beforein', function (e, page) {
          switch (page.route.path) {
            case '/':
            case '/home':
              // 首頁
              // 焦點預購
              store.dispatch('home/updateHomeProductList'); // 會員點數
              // store.dispatch('auth/updateMemberPointRecord');
              // 未讀訊息

              store.dispatch('updateNoticeUnreadNum'); // 當前購物車數量

              store.dispatch('cart/updateCurrentCartNum');
              break;

            case '/member_center':
              // 會員中心
              // store.dispatch('auth/updateMemberPointRecord');
              // 會員點數
              store.dispatch('auth/updateMemberPointRecord'); // 待領取訂單

              store.dispatch('auth/updateUnreceiveOrdersNum'); // 未讀優惠券

              store.dispatch('auth/updateMemberCouponUnread');
              break;

            default:
              if (page.route.path.indexOf('/product_detailed') > -1) {
                // 當前購物車數量
                store.dispatch('cart/updateCurrentCartNum');
              }

              break;
          }
        });

        if (store.state.auth.isLogined) {
          store.dispatch('updateMemberRelatedData');
        }
        /**
         * 跳轉特定頁面
         * 跳轉頁面是載入App後轉頁的方式
         * 
         * 1) 由routes.js直接載入的方式請直接在routes.js處理邏輯
         */


        if (parseUrl.go_page && parseUrl.go_page_mode !== 'route_load') {
          // 清掉query指令，避免換頁時重複執行
          history.pushState(null, '', location.origin); // 產品詳細頁

          if (parseUrl.go_page === 'product_detailed') {
            f7.view.main.router.navigate("/product_detailed/".concat(parseUrl.product_id, "/").concat(parseUrl.cart_type));
          }
        }
      });
    });

    var getAppRouter = function getAppRouter() {
      return f7.view.main.router;
    };

    var openCartModal = function openCartModal() {
      // 被設黑名單
      if (store.state.auth.is_blacklist == mukiConst.blackList.YES) {
        alertCustom("訊息提示", mukiConst.blackList.MESSAGE, function () {});
        return;
      }

      f7.popup.open('#popup-cart');
    };

    var goCart = function goCart(cartType, nowCartNumber) {
      if (nowCartNumber == 0) {
        alertCustom("訊息提示", "購物車是空的!", function () {
          resolve();
        });
      } else {
        f7.popup.close('#popup-cart');

        _direct_page("/cart_step1/".concat(cartType));
      }
    }; // ==== 模組 ====
    // 手機原生虛擬返回鍵綁定


    function indexBackAction() {
      muki_back_action(2, function () {
        onAndroidBackAction();
      });
    }

    function inpageBackAction() {
      muki_back_action(1, function () {
        onAndroidBackAction();
      });
    }

    onMounted(function () {
      f7ready(function () {
        // Option 1. Using one 'page:init' handler for all pages
        $$(document).on('page:beforein', function (e) {
          // console.log('f7.view.current.router.currentRoute.path',f7.view.current.router.currentRoute.path);
          if (f7.view.current.router.currentRoute.path == '/home') {
            indexBackAction();
          } else if (f7.view.current.router.currentRoute.path == '/login') {
            indexBackAction();
          } else {
            inpageBackAction();
          }
        }); // $$(document).keyup(function(e){
        //     if(e.key === "Backspace") {
        //         console.log('Delete key/ backspace');
        //         console.log('f7.view.current.router.currentRoute.path',f7.view.current.router.currentRoute.path);
        //         if (f7.view.current.router.currentRoute.path == '/home'){
        //             indexBackAction();
        //         } else if (f7.view.current.router.currentRoute.path == '/login') {
        //         }else{
        //             inpageBackAction();
        //         }
        //     }
        // });
      });
    });
    indexBackAction(); // 取得全域 locale 實體

    var _useI18n = useI18n(),
        t = _useI18n.t,
        locale = _useI18n.locale;

    locale.value = store.state.locale || mukiConst.locale['TW']; // Framework7 Parameters

    var f7params = {
      name: "trueway",
      // App name
      theme: "auto",
      // Automatic theme detection
      // App store
      store: store,
      // App routes
      routes: routes,
      touch: {
        mdTouchRipple: false
      },
      navbar: {
        iosCenterTitle: true,
        mdCenterTitle: true,
        auroraCenterTitle: true
      },
      view: {
        // 打開 broweerHistory 在需要back page時可能會有問題
        // 故僅用於開發
        // browserHistory: process.env.NODE_ENV === 'development' ? true:false,
        xhrCache: false,
        iosSwipeBack: false
      },
      // picker
      picker: {
        renderToolbar: function renderToolbar() {
          return '<div class="toolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '</div>' + '<div class="right">' + '<a href="#" class="link sheet-close popover-close reset">完成</a>' + '</div>' + '</div>' + '</div>';
        }
      },
      calendar: {
        locale: 'zh-TW',
        dateFormat: {
          month: 'long',
          day: 'numeric'
        }
      },
      photoBrowser: {
        theme: 'dark',
        popupCloseLinkText: t('photoBrowser.bannerPhotoBrowser')
      },
      dialog: {
        buttonOk: t('dialog.buttonOk'),
        buttonCancel: t('dialog.buttonCancel')
      }
    }; // 自動計算基礎px

    var computeRatioOfBaseSize = function computeRatioOfBaseSize() {
      var initSize = 14;
      var htmlEl = document.querySelector("html");
      var windowWidth = htmlEl.clientWidth > 768 ? 768 : htmlEl.clientWidth;
      var baseSize = Number(windowWidth) / 375 * initSize;
      if (baseSize > 16) baseSize = 16;
      if (baseSize < 14) baseSize = 14;
      document.documentElement.style.setProperty('--f7-font-size', baseSize + 'px');
      htmlEl.style.fontSize = baseSize + "px";
    }; // 滑動偵測


    var ScrollDetect = function ScrollDetect() {
      function check(page) {
        var page = page && page.el || f7.view.main.router.currentPageEl;
        if (!page) return;
        $('body').removeClass('is-scrolling');
        var pageContent = page.querySelector('.page-content');

        if (pageContent.scrollTop > 20) {
          $('body').addClass('is-scrolling');
        } else {
          $('body').removeClass('is-scrolling');
        }
      }

      $$(document).on('page:afterin', function (e, page) {
        check(page);
        $('.view-main .page-content').on('scroll', function (e) {
          check();
        });
      });
      $('.view-main .page-content').on('scroll', function (e) {
        check();
      });
    }; // segmented tab


    var SegmentedTab = {
      setActive: function setActive(tabLink) {
        // f7 內建 不會移動 tab inner，導致選到的 tab link有可能會部分被擋住，故採用自行移動方式
        var that = this;
        var tabLink = $(tabLink);
        if (!tabLink.length) return;
        var toolbarInner = tabLink.closest('.toolbar-inner');
        var toolbarInnerW = toolbarInner[0].clientWidth;
        var currentScrollLeft = toolbarInner[0].scrollLeft;
        var tabLinkPos = tabLink.position();
        var diff = tabLink[0].offsetLeft + tabLink[0].clientWidth - (currentScrollLeft + toolbarInnerW);
        var target = currentScrollLeft;

        if (tabLinkPos.left < 0) {
          // btn 太左邊
          target = currentScrollLeft + tabLinkPos.left;
        } else if (diff > 0) {
          // btn 太右邊
          target = currentScrollLeft + diff;
        }

        toolbarInner.animate({
          scrollLeft: target
        }, 300);
        that.updateSegmented(tabLink);
      },
      updateSegmented: function updateSegmented(tabLink) {
        // f7 內建 移動 segement 的位置會有誤差，故改採自行修改位置的方式
        var tabLink = $(tabLink);
        if (!tabLink.length) return;
        var toolbarInner = tabLink.closest('.toolbar-inner');
        var tabLinkW = tabLink.outerWidth();
        var segEl = toolbarInner.find('.tab-link-bg-hilighter');
        segEl.css('width', tabLinkW);
        segEl.css('left', tabLink.position().left + toolbarInner[0].scrollLeft);
      },
      init: function init() {
        var that = this;
        $('body').on('click', '.tab-link', function (e) {
          that.setActive(e.currentTarget);
        });
        $$(document).on('page:beforein', function (e, page) {
          that.updateSegmented($(page.$el).find('.tabbar-scrollable .tab-link-active'));
        });
      }
    }; // 切換語系

    var switchLanguage = function switchLanguage(e) {
      if (e.target.checked) {
        // 中文
        store.commit('updateLocale', mukiConst.locale.TW);
      } else {
        // 英文
        store.commit('updateLocale', mukiConst.locale.EN);
      }
    }; // currentPath


    var currentPath = ref(null); // 是否要登出

    var isLogout = computed(function () {
      return store.state.isLogout;
    });
    watch(isLogout, function (newValue) {
      if (newValue == 1) {
        Logout();
      }
    }); // 每10分鐘執行一次確認是否要把使用者登出

    var intervalId = setInterval(function () {
      YoungSun.get_member_login_state({
        member_card: store.state.auth.member_card,
        member_mobile: store.state.auth.mobile
      }).then(function (res) {
        var data = res.data,
            status = res.status;

        if (data) {
          store.commit('setLogout', "".concat(data.res_data.cancel_member == 'Y' ? '1' : '0')); // console.log('是否把使用者登出', isLogout.value);
        }
      }).catch(function (error) {
        console.error('呼叫API錯誤:', error);
      });
    }, 10 * 60 * 1000); //10分鐘

    onMounted(function () {
      computeRatioOfBaseSize();
      window.addEventListener("resize", computeRatioOfBaseSize);
      ScrollDetect();
      SegmentedTab.init(); // ==== PAGE BEFORE IN 頁面事件 ====

      $$(document).on('page:beforein', function (e, page) {
        setTimeout(function () {
          if (f7.view.current) {
            var toolbarPath = f7.view.current.router.currentRoute.path;
            currentPath.value = toolbarPath;
          }
        }, 0);
      }); // f7.popup.open('#popup-cart')
    });
    return function (_ctx, _cache) {
      var _component_f7_link = _resolveComponent("f7-link");

      var _component_f7_block = _resolveComponent("f7-block");

      var _component_NumBadge = _resolveComponent("NumBadge");

      var _component_f7_page = _resolveComponent("f7-page");

      var _component_f7_view = _resolveComponent("f7-view");

      var _component_f7_panel = _resolveComponent("f7-panel");

      var _component_CartIconDisplayer = _resolveComponent("CartIconDisplayer");

      var _component_f7_toolbar = _resolveComponent("f7-toolbar");

      var _component_f7_app = _resolveComponent("f7-app");

      var _component_Loading = _resolveComponent("Loading");

      var _component_f7_icon = _resolveComponent("f7-icon");

      var _component_f7_button = _resolveComponent("f7-button");

      return _openBlock(), _createBlock(_Fragment, null, [_createVNode(_component_f7_app, f7params, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_panel, {
            left: "",
            cover: "",
            backdrop: "",
            resizable: "",
            onOpen: _cache[13] || (_cache[13] = function ($event) {
              return _ctx.onPanelOpen();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_view, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_page, null, {
                    default: _withCtx(function () {
                      return [_createVNode("div", _hoisted_1, [_createVNode(_component_f7_block, {
                        class: "panel-top-block"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_f7_link, {
                            class: "text-left",
                            "panel-close": ""
                          }, {
                            default: _withCtx(function () {
                              return [_hoisted_2];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode("div", _hoisted_3, [_createVNode("ul", null, [_createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[1] || (_cache[1] = function ($event) {
                          return getAppRouter().navigate('/news_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_4, _hoisted_5];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[2] || (_cache[2] = function ($event) {
                          return getAppRouter().navigate('/preorder_product_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_6, _hoisted_7];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[3] || (_cache[3] = function ($event) {
                          return _unref(goMobileStore)({
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_8, _hoisted_9];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[4] || (_cache[4] = function ($event) {
                          return getAppRouter().navigate('/proposal_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_10, _hoisted_11];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[5] || (_cache[5] = function ($event) {
                          return getAppRouter().navigate('/discount_info', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_12, _hoisted_13];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        onClick: _cache[6] || (_cache[6] = function ($event) {
                          return getAppRouter().navigate('/dm_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_14, _hoisted_15];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        onClick: _cache[7] || (_cache[7] = function ($event) {
                          return getAppRouter().navigate('/member_center', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_16, _createVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_NumBadge, {
                            bold: "",
                            bg: "#ff5970",
                            showAsDot: _unref(store).state.auth.is_member_coupon_unread
                          }, null, 8, ["showAsDot"])])];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[8] || (_cache[8] = function ($event) {
                          return getAppRouter().navigate('/order_records', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_19, _hoisted_20];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        view: ".view-main",
                        onClick: _cache[9] || (_cache[9] = function ($event) {
                          return getAppRouter().navigate('/shopping_records', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_21, _hoisted_22];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link mail-list panel-close",
                        view: ".view-main",
                        onClick: _cache[10] || (_cache[10] = function ($event) {
                          return getAppRouter().navigate('/mail_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_23, _createVNode("div", _hoisted_24, [_hoisted_25, _createVNode(_component_NumBadge, {
                            bold: "",
                            num: _unref(store).state.notice_unread_num
                          }, null, 8, ["num"])])];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        onClick: _cache[11] || (_cache[11] = function ($event) {
                          return getAppRouter().navigate('/play_ground', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_26, _hoisted_27];
                        }),
                        _: 1
                      })]), _createVNode("li", null, [_createVNode(_component_f7_link, {
                        class: "panel-menu-link panel-close",
                        onClick: _cache[12] || (_cache[12] = function ($event) {
                          return getAppRouter().navigate('/store_list', {
                            animate: false
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_28, _hoisted_29];
                        }),
                        _: 1
                      })])])])])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_f7_view, {
            main: "",
            class: "safe-areas",
            url: "/"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_toolbar, {
                bottom: "",
                class: "toolbar-menu"
              }, {
                default: _withCtx(function () {
                  return [_createVNode("div", {
                    class: "toolbar-menu-bg",
                    style: "background-image:url(".concat(require('@/assets/images/general/footerbg.png'), ")")
                  }, null, 4), _createVNode("div", _hoisted_30, [_createVNode(_component_f7_link, {
                    onClick: _cache[14] || (_cache[14] = function ($event) {
                      return _ctx.$window._refresh_page('/home');
                    }),
                    class: ["link menu-link", {
                      'is-active': currentPath.value == '/' || currentPath.value == '/home'
                    }]
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_31, _hoisted_32];
                    }),
                    _: 1
                  }, 8, ["class"])]), _createVNode("div", _hoisted_33, [_createVNode(_component_f7_link, {
                    onClick: _cache[15] || (_cache[15] = function ($event) {
                      return _ctx.$window._refresh_page('/dm_list');
                    }),
                    class: ["link menu-link", {
                      'is-active': currentPath.value == '/dm_list'
                    }]
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_34, _hoisted_35];
                    }),
                    _: 1
                  }, 8, ["class"])]), _createVNode("div", _hoisted_36, [_createVNode("a", {
                    onClick: _cache[16] || (_cache[16] = function ($event) {
                      return _ctx.$window._refresh_page('/store_list');
                    }),
                    class: ["link menu-link", {
                      'is-active': currentPath.value == '/store_list'
                    }]
                  }, [_hoisted_37, _hoisted_38], 2)]), _createVNode("div", _hoisted_39, [_createVNode("a", {
                    onClick: _cache[17] || (_cache[17] = function ($event) {
                      return _ctx.$window._refresh_page('/member_center');
                    }),
                    class: ["link menu-link", {
                      'is-active': currentPath.value == '/member_center'
                    }]
                  }, [_hoisted_40, _hoisted_41], 2)]), _createVNode("div", _hoisted_42, [_createVNode("a", {
                    transition: "f7-fade",
                    "ignore-cache": true,
                    class: ["link menu-link", {
                      'is-active': currentPath.value == '/cart_step1'
                    }]
                  }, [_createVNode(_component_CartIconDisplayer, {
                    icon: "icon-cart",
                    all: "",
                    onClick: _cache[18] || (_cache[18] = function ($event) {
                      return openCartModal();
                    })
                  }), _hoisted_43], 2)])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 16), _createVNode(_component_Loading, {
        watchStore: ""
      }), _createVNode("div", _hoisted_44, [_createVNode("div", _hoisted_45, [_createVNode("div", _hoisted_46, [_createVNode("div", _hoisted_47, [_hoisted_48, _createVNode("div", _hoisted_49, [_createVNode("div", _hoisted_50, [_createVNode(_component_f7_link, {
        class: "",
        "popup-close": ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_51];
        }),
        _: 1
      })])])]), _createVNode("div", _hoisted_52, [_createVNode("div", _hoisted_53, [_createVNode("div", _hoisted_54, [_createVNode("div", _hoisted_55, [_hoisted_56, _createVNode("div", _hoisted_57, [_hoisted_58, _createVNode("button", _hoisted_59, [_createVNode(_component_f7_icon, {
        f7: "camera_fill"
      })])]), _hoisted_60])])])])])])]), _createVNode("div", _hoisted_63, [_createVNode("div", _hoisted_64, [_createVNode("div", _hoisted_65, [_createVNode("div", _hoisted_66, [_createVNode("div", _hoisted_67, [_hoisted_68, _hoisted_69, _createVNode("div", _hoisted_70, [_createVNode("a", _hoisted_71, [_createVNode(_component_f7_icon, {
        f7: "multiply"
      })])])])]), _hoisted_72])])]), _createVNode("div", _hoisted_73, [_createVNode("div", _hoisted_74, [_createVNode("div", _hoisted_75, [_hoisted_76, _createVNode("div", {
        class: "page-content popup-modal-centered",
        onClick: _cache[21] || (_cache[21] = _withModifiers(function ($event) {
          return _ctx.window.f7.popup.close('#popup-cart');
        }, ["self"]))
      }, [_createVNode("div", _hoisted_77, [_createVNode("div", _hoisted_78, [_createVNode("div", _hoisted_79, [_hoisted_80, _createVNode("div", _hoisted_81, [_createVNode(_component_f7_button, {
        type: "button",
        class: "btn-outline-theme size-h-40px btn-radius-pill",
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return goCart(__unimport_mukiConst.cartType.ONLINE_PREORDER, _unref(store).state.cart.onlinePreorderNum);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 立即結帳(" + _toDisplayString(_unref(store).state.cart.onlinePreorderNum) + ") ", 1)];
        }),
        _: 1
      })])]), _createVNode("div", _hoisted_82, [_hoisted_83, _createVNode("div", _hoisted_84, [_createVNode(_component_f7_button, {
        type: "button",
        class: "btn-outline-sec size-h-40px btn-radius-pill",
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return goCart(__unimport_mukiConst.cartType.ACTION_STORE, _unref(store).state.cart.actionStoreNum);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 立即結帳(" + _toDisplayString(_unref(store).state.cart.actionStoreNum) + ") ", 1)];
        }),
        _: 1
      })])]), _hoisted_85])])])])])])], 64);
    };
  }
};